import React, { useState } from "react";
import { MdLockOutline, MdMailOutline } from "react-icons/md";
import { useAuth } from "../context/AuthContext";

const Login = ({ onLoginSuccess }) => {
  const { login } = useAuth();
  const [formData, setFormData] = useState({
    email: "admin@kalikambalmotors.com",
    password: "",
  });
  const [error, setError] = useState("");

  const handleSubmit = async (event) => {
    event.preventDefault();
    const result = await login(formData);

    if (!result.ok) {
      setError(result.message);
      return;
    }

    setError("");
    onLoginSuccess();
  };

  return (
    <main className="min-h-screen bg-slate-950 text-slate-100 flex items-center justify-center px-4 py-10">
      <section className="w-full max-w-md rounded-lg border border-slate-800 bg-white text-slate-900 shadow-2xl">
        <div className="border-b border-slate-100 px-6 py-5">
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-amber-600">
            Kalikambal Motors
          </p>
          <h1 className="mt-2 text-2xl font-bold">Admin Login</h1>
        </div>

        <form className="space-y-4 px-6 py-6" onSubmit={handleSubmit}>
          <label className="block">
            <span className="text-sm font-semibold text-slate-700">Email</span>
            <span className="mt-2 flex items-center gap-2 rounded-md border border-slate-200 bg-slate-50 px-3 py-2 focus-within:border-amber-500 focus-within:bg-white">
              <MdMailOutline className="text-lg text-slate-400" />
              <input
                type="email"
                value={formData.email}
                onChange={(event) =>
                  setFormData((current) => ({
                    ...current,
                    email: event.target.value,
                  }))
                }
                className="w-full bg-transparent text-sm outline-none"
                placeholder="admin@example.com"
              />
            </span>
          </label>

          <label className="block">
            <span className="text-sm font-semibold text-slate-700">Password</span>
            <span className="mt-2 flex items-center gap-2 rounded-md border border-slate-200 bg-slate-50 px-3 py-2 focus-within:border-amber-500 focus-within:bg-white">
              <MdLockOutline className="text-lg text-slate-400" />
              <input
                type="password"
                value={formData.password}
                onChange={(event) =>
                  setFormData((current) => ({
                    ...current,
                    password: event.target.value,
                  }))
                }
                className="w-full bg-transparent text-sm outline-none"
                placeholder="Enter password"
              />
            </span>
          </label>

          {error && (
            <p className="rounded-md bg-red-50 px-3 py-2 text-sm font-medium text-red-600">
              {error}
            </p>
          )}

          <button
            type="submit"
            className="w-full rounded-md bg-amber-500 px-4 py-2.5 text-sm font-bold text-slate-950 transition hover:bg-amber-400"
          >
            Login
          </button>
        </form>
      </section>
    </main>
  );
};

export default Login;
